'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MOBILE_UA_PARTS = {
  ios: 'iP(hone|od|ad)',
  android: 'Android'
};

exports.default = MOBILE_UA_PARTS;
module.exports = exports['default'];